import { gql } from 'apollo-boost'

const SCRAPING_LOGS_FOR_SESSION = gql`
  query scrapingLogsForSessionId(
    $sessionId: ID!
    $page: Int!
    $filters: ScrapingLogFiltersInput
  ) {
    scrapingLogsForSessionId(
      sessionId: $sessionId
      page: $page
      filters: $filters
    ) {
      scrapingLogs {
        menuId
        message
        severity
        timestamp
      }
      total
    }
  }
`

export default SCRAPING_LOGS_FOR_SESSION
